import HardwareCard from "./HardwareCard";

export function KassensystemHardwareSection() {
  return (
    <div className="py-16 sm:py-20 w-full">
      <div className="mx-auto w-full max-w-7xl px-6">
        <h2 className="text-center text-4xl mb-6">Kassensystem Hardware</h2>
        <h3 className="text-center text-xl text-muted-foreground">
          Registrierkassen
        </h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-8 my-10">
          <HardwareCard
            imageSrc="/index/products/Kassenbildschirm_Pos.png"
            imageAlt="Dein Kassensystem von SDI: So flexibel wie Du selbst."
            title="All-in-One Kassensystem"
            subtitle="Nur 2.289,00 €"
            description="Hol Dir die flexible Tablet-Kasse! SDI vereint alle wichtigen Funktionen in einem kompakten Gerät, mit oder ohne Tresenhalterung."
            linkText="Unverbindlich anfragen"
            linkUrl="/support?"
          />
          <HardwareCard
            imageSrc="/hardware/BonUndEtiketten.jpg"
            imageAlt="Bon- und Etikettendrucker"
            title="Bon- & Etikettendrucker"
            subtitle="Nur 249,00 €"
            description="Vielseitiger Drucker für Bons und Etiketten – für jeden Einsatzbereich."
            linkText="Unverbindlich anfragen"
            linkUrl="/support"
          />
          <HardwareCard
            imageSrc="/hardware/DatalogicQuickScan.jpg"
            imageAlt="Datalogic QuickScan"
            title="Datalogic QuickScan"
            subtitle="Nur 149,00 €"
            description="Schneller QuickScan für reibungslosen Betrieb an der Kasse."
            linkText="Unverbindlich anfragen"
            linkUrl="/support"
          />
          <HardwareCard
            imageSrc="/hardware/DMD30.jpg"
            imageAlt="Kundendisplay DMD30"
            title="Kundendisplay DMD30"
            subtitle="Nur 149,00 €"
            description="Kompaktes Kundendisplay für transparente Preisanzeige am Point-of-Sale."
            linkText="Unverbindlich anfragen"
            linkUrl="/support"
          />
        </div>
      </div>
    </div>
  );
}
